import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = [ "toast" ]

  async perform(event) {
    event.preventDefault()

    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch (_) {
      const ta = document.createElement("textarea")
      ta.value = this.textValue
      ta.setAttribute("readonly", "")
      ta.style.position = "absolute"
      ta.style.left = "-9999px"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy") } catch (__) { /* noop */ }
      document.body.removeChild(ta)
    }

    const container = document.getElementById("toast-notifications")
    if (container && this.hasToastTarget) {
      const clone = this.toastTarget.content.cloneNode(true)
      container.appendChild(clone)
    }
  }
}
